import { AnnotationToolNoAccessPage } from '@verantos-dev/annotation-tool-ui-routes';
import { LandingPage } from '@verantos-dev/el-feature-landing-page';
import { getUrlForSidebarAppId } from '@verantos-dev/shared-layout';

import { useAnnotationToolAllowedApps } from './useAnnotationToolAllowedApps';
import { useAnnotationToolSidebarConfig } from './useAnnotationToolSidebarConfig';

/**
 * Internal Platform-specific container for LandingPage.
 * Redirects to the first app the user has access to based on their roles.
 * With no Annotation Tool app allowed, hands off to AnnotationToolNoAccessPage,
 * which sends users entitled to another Curation Platform app there and shows
 * the no-access message to everyone else.
 */
export const AnnotationToolLandingPage = () => {
  const sidebarConfig = useAnnotationToolSidebarConfig();
  const allowedApps = useAnnotationToolAllowedApps();

  if (allowedApps.length === 0) {
    return <AnnotationToolNoAccessPage />;
  }

  return (
    <LandingPage
      apps={allowedApps}
      getUrl={(appId) => getUrlForSidebarAppId(sidebarConfig, appId)}
    />
  );
};
